import "./buyNow.scss";
import Typography from "../../../../../common/Typography";
import ArrowNarrowLeft from "../../../../../assets/ArrowNarrowLeft";

const BuyNowButton = ({
  data,
  handleClick,
  isShowRenewTxt = false,
  primaryTextSize = "text-md",
  secondaryTextSize = "text-sm",
}) => {
  const expiryDuration = data?.expiry?.duration;
  const expiryPeriod = `${
    data?.expiry?.duration > 1
      ? data?.expiry?.period
      : data?.expiry?.period?.slice(0, -1)
  }`;

  return (
    <div
      onClick={handleClick}
      className="buy-now-cta"
      style={{ backgroundColor: data.theme_color }}
    >
      <div className="main-text">
        <Typography
          tag="span"
          weight="medium"
          size={primaryTextSize}
          style={{ color: data.text_color }}
        >
          {isShowRenewTxt ? "Re-new" : "Buy now"} at {data.price}
        </Typography>
        <ArrowNarrowLeft
          rotate={180}
          color={data.text_color}
          width={primaryTextSize === "text-md" ? "20" : "24"}
          height={primaryTextSize === "text-md" ? "20" : "24"}
        />
      </div>
      <Typography size={secondaryTextSize} style={{ color: data.text_color }}>
        Valid for {`${expiryDuration} ${expiryPeriod}`}
      </Typography>
    </div>
  );
};

export default BuyNowButton;
